export default __webpack_public_path__ + "static/media/man.1e2244e0.png";